import { Badge } from '@kalos/ui';

/** "TRADE <name>" pill; renders nothing without a name. */
export const TradeChip = ({ name }: { name?: string }) => {
  if (!name) return null;
  return (
    <Badge variant="secondary" className="w-fit gap-1.5 font-normal">
      <span className="text-[10px] font-semibold tracking-wide">TRADE</span>
      {name}
    </Badge>
  );
};
